export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14136.58af6f04.jpg";